import { useTranslation } from 'react-i18next';

import { useGermanStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/German/hooks/useGermanStatusBoard';
import { useStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/Standart/hooks/useStatusBoard';

import Select from '../../../../components/Select';

type FrequencyFieldProps = {
  isGerman?: boolean;
  titleHidden?: boolean;
};

const splitOptions = [
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3',
  },
  {
    value: '4',
    label: '4',
  },
  {
    value: '5',
    label: '5',
  },
];

const FrequencyField = ({ isGerman = false, titleHidden = false }: FrequencyFieldProps) => {
  const { t } = useTranslation();

  const {
    setSplit,
    isGreaterTarget,
    split,
  } = isGerman? useGermanStatusBoard() : useStatusBoard();

  return (
    <Select
      titleClassName="truncate max-w-[85%]"
      options={splitOptions}
      onChange={(value) => setSplit(value.value)}
      title={titleHidden ? '' : (isGreaterTarget ? t('splitInYear') : t('frequency'))}
      placeholder={t('selectValue')}
      value={[
        {
          value: split,
          label: split,
        },
      ]}
      isBlueBg
    />
  ); 
};

export default FrequencyField;
